import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './sector-calendar.reducer';

export const SectorCalendarDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const sectorCalendarEntity = useAppSelector(state => state.sectorCalendar.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="sectorCalendarDetailsHeading">
          <Translate contentKey="crawlerBackendApp.sectorCalendar.detail.title">SectorCalendar</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{sectorCalendarEntity.id}</dd>
          <dt>
            <span id="day">
              <Translate contentKey="crawlerBackendApp.sectorCalendar.day">Day</Translate>
            </span>
          </dt>
          <dd>
            {sectorCalendarEntity.day ? (
              <TextFormat value={sectorCalendarEntity.day} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
        </dl>
        <Button tag={Link} to="/sector-calendar" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/sector-calendar/${sectorCalendarEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SectorCalendarDetail;
